/* eslint-disable react/prop-types */
import { createContext } from "react";
import Pool from "./user-pool";
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";

const AccountContext = createContext();

const Account = ({ children }) => {
  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject();
          } else {
            resolve(session);
          }
        });
      } else {
        reject();
      }
    });
  };
  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });
      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          resolve(data);
        },
        onFailure: (err) => {
          reject(err);
        },
        newPasswordRequired: (data) => {
          resolve(data);
        },
      });
    });
  };
  return (
    <AccountContext.Provider value={{ authenticate, getSession }}>
      {children}
    </AccountContext.Provider>
  );
};

export { Account, AccountContext };
